import { onError } from 'apollo-link-error';

const errorLink = onError(({ response, operation, graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message/* , locations, path */ }) =>
      console.warn(
        `[GraphQL error]: Message: ${message}`,
      ),
    );
    return;
  }
  if (networkError) {
    console.warn(`[Network error]: ${networkError}`);
    return;
  }
  if (operation.operationName === 'Viewer') {
    // User used an invalid token, remove it.
    localStorage.removeItem('authToken');
    response.data = { viewer: { user: null, __typename: 'Viewer' } };
    response.errors = null;
  }
});
export default errorLink;



// WEBPACK FOOTER //
// ./src/data/links/errorLink.js